import axios from 'axios'

import * as constants from './constants'

export const getConversation = (id, channel) => dispatch => {
    dispatch({
        type: constants.GET_HISTORY_START,
    })

    axios('/api/conversations', {
        params: { id, channel },
    })
        .then(res => {
            console.log('UN', res.data, 'for', channel)
            const stopBotParams = {
                account: res.data.conversation[0].AccountId,
                conversationId: res.data.conversation[0].ConversationId,
            }
            axios({
                method: 'get',
                url: '/api/conversations/stop-bot-events',
                params: stopBotParams,
            })
                .then(stopBotRes => stopBotRes.data.Items.map(e => {
                    e.Timestamp = e.ts
                    e.stopBotEvent = true
                    return e
                }))
                .then(events => {
                    const conversation = [
                        ...res.data.conversation,
                        ...events,
                    ].sort((a, b) => (a.Timestamp > b.Timestamp ? 1 : -1))
                    res.data.conversation = conversation
                    dispatch({
                        type: constants.GET_HISTORY_SUCCESS,
                        payload: res.data,
                    })
                })
                .catch(e => {
                    console.log('Caught error:', e)
                    dispatch([])
                })
        })
        .catch(err => {
            const payload = err.response?.data?.key || 'Conversation not found'

            dispatch({
                type: constants.GET_HISTORY_FAIL,
                payload,
            })
        })
}
export const getStatuses = (AccountId, ConversationId) => dispatch => {
    dispatch({
        type: constants.GET_STATUSES_START_REPLY,
    })

    axios({
        method: 'post',
        url: '/api/conversations',
        data: { AccountId, ConversationId },
    })
        .then(res => {
            const dataItems = JSON.parse(res.data.Items)
            // eslint-disable-next-line no-console
            dispatch({
                type: constants.GET_STATUSES_SUCCESS_REPLY,
                payload: dataItems,
            })
        })
        .catch(() => {
            dispatch({
                type: constants.GET_STATUSES_FAIL_REPLY,
            })
        })
}

export const createMessage = (newMessageObject, token) => dispatch => {
    dispatch({
        type: constants.CREATE_MESSAGE_START,
    })

    axios({
        url: '/api/operators/message',
        method: 'put',
        headers: {
            authorization: token,
            'x-stop-ai-communication': 'yes',
        },
        data: { newMessageObject },
    })
        .then(res => {
            dispatch({
                type: constants.CREATE_MESSAGE_SUCCESS,
                payload: res.data,
            })
        })
        .catch(err => {
            console.log(err)

            dispatch({
                type: constants.CREATE_MESSAGE_FAIL,
            })
        })
}

export const handleUserNewMessage = data => dispatch => {
    dispatch({
        type: constants.USER_NEW_MESSAGE,
        payload: data,
    })
}
